<template>
  <div>
    <div class="ag-form-control radio-group">
      <label for="">Mode</label>
      <div class="form-check form-check-inline all-radio">
        <input
          class="form-check-input"
          type="radio"
          name="mode"
          v-model="data.mode"
          id="modeAll"
          value="All"
        />
        <label class="form-check-label" for="modeAll">{{$t("all")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="mode"
          v-model="data.mode"
          id="modelEnforcing"
          value="Enforcing"
        />
        <label class="form-check-label" for="modelEnforcing">{{$t("enforcing")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="mode"
          v-model="data.mode"
          id="modeDiscovery"
          value="Discovery"
        />
        <label class="form-check-label" for="modeDiscovery">{{$t("discovery")}}</label>
      </div>
    </div>

    <div class="ag-form-control radio-group">
      <label for="">{{$t("result")}}</label>
      <div class="form-check form-check-inline all-radio">
        <input
          class="form-check-input"
          type="radio"
          name="result"
          v-model="data.result"
          id="inlineRadio1"
          value="All"
        />
        <label class="form-check-label" for="inlineRadio1">{{$t("all")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="result"
          v-model="data.result"
          id="inlineRadio2"
          value="Allow"
        />
        <label class="form-check-label" for="inlineRadio2">{{$t("allow")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="result"
          v-model="data.result"
          id="inlineRadio3"
          value="Block"
        />
        <label class="form-check-label" for="inlineRadio3">{{$t("block")}}</label>
      </div>
    </div>

    <div
      class="ag-form-control radio-group"
    >
      <label for="">{{$t("privilege")}}</label>
      <div class="form-check form-check-inline all-radio">
        <input
          class="form-check-input"
          type="radio"
          name="privilege"
          v-model="data.privilege"
          id="privilegeAll"
          value="All"
        />
        <label class="form-check-label" for="privilegeAll">{{$t("all")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="privilege"
          v-model="data.privilege"
          id="privilegeElevated"
          value="Elevated"
        />
        <label class="form-check-label" for="privilegeElevated">{{$t("elevated")}}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="privilege"
          v-model="data.privilege"
          id="privilegeNotElevated"
          value="NotElevated"
        />
        <label class="form-check-label" for="privilegeNotElevated"
          >{{$t("notElevated")}}</label
        >
      </div>
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("commandLine")}}</label>
      <input
        class="w-100 form-control"
        v-model="data.commandLine"
        type="text"
        maxlength="191"
        placeholder="Type Command Line"
      />
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("operationsys")}}</label>
      <select
        class="form-select form-control form-select-sm w-100"
        v-model="data.os"
        placeholder="Select an OS"
      >
        <option value="" disabled selected>{{$t("selectAnOS")}}</option>
        <option v-for="(option, key) in source.os" :key="key" :value="option">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";
import api from "@/store/axiosAgsc";

export default {
  components: {},
  props: {
    value: {
      type: String,
    },
    type: {
      type: String,
      default: "single",
    },
  },
  data() {
    return {
      Roles: Roles,
      selectedGroups: [],
      selectedSite: null,
      data: {
        os: "",
        result: "",
        mode: "",
        privilege: "",
        commandLine: "",
        protectionStatusFilter:""
      },
      source: {
        actions: [
          {
            id: "All",
            label: "All",
            name: "Action",
          },
          {
            id: "Process Check",
            label: "Process Check",
            name: "Action",
          },
          {
            id: "File Access",
            label: "File Access",
            name: "Action",
          },
          {
            id: "Registry Access",
            label: "Registry Access",
            name: "Action",
          },
          {
            id: "Memory Access",
            label: "Memory Access",
            name: "Action",
          },
          {
            id: "Code Load",
            label: "Code Load",
            name: "Action",
          },
          {
            id: "Agent Event",
            label: "Agent Event",
            name: "Action",
          },
        ],
        operations: [
          {
            id: "Delete",
            label: "Delete",
            name: "Operation",
          },
          {
            id: "SetValue",
            label: "SetValue",
            name: "Operation",
          },
          {
            id: "DeleteValue",
            label: "DeleteValue",
            name: "Operation",
          },
          {
            id: "SetInformationKey",
            label: "SetInformationKey",
            name: "Operation",
          },
          {
            id: "Rename",
            label: "Rename",
            name: "Operation",
          },
          {
            id: "RenameInto",
            label: "RenameInto",
            name: "Operation",
          },
          {
            id: "PreLoadKey",
            label: "PreLoadKey",
            name: "Operation",
          },
          {
            id: "PreUnloadKey",
            label: "PreUnloadKey",
            name: "Operation",
          },
          {
            id: "SetKeySecurity",
            label: "SetKeySecurity",
            name: "Operation",
          },
          {
            id: "RestoreKey",
            label: "RestoreKey",
            name: "Operation",
          },
          {
            id: "ReplaceKey",
            label: "ReplaceKey",
            name: "Operation",
          },
        ],
        lrps: [
          {
            id: "All",
            label: "All",
            name: "LRP",
          },
          {
            id: "Upload",
            label: "Upload",
            name: "LRP",
          },
          {
            id: "Failed",
            label: "Failed",
            name: "LRP",
          },
          {
            id: "Invalid",
            label: "Invalid",
            name: "LRP",
          },
        ],
        pdps: [
          {
            id: "All",
            label: "All",
            name: "PDP",
          },
          {
            id: "Policy",
            label: "Policy",
            name: "PDP",
          },
          {
            id: "Installer",
            label: "Installer",
            name: "PDP",
          },
          {
            id: "Download",
            label: "Download",
            name: "PDP",
          },
          {
            id: "Failed",
            label: "Failed",
            name: "PDP",
          },
          {
            id: "Error",
            label: "Error",
            name: "PDP",
          },
        ],
        agentHosts: [
          {
            id: "All",
            label: "All",
            name: "Agent Host",
          },
          {
            id: "SessionInfo",
            label: "Session Info",
            name: "Agent Host",
          },
          {
            id: "Tasks",
            label: "Tasks",
            name: "Agent Host",
          },
          {
            id: "Startup",
            label: "Startup",
            name: "Agent Host",
          },
          {
            id: "ProtectionStatus",
            label: "Protection Status",
            name: "Agent Host",
          },
          {
            id: "AutoUpdate",
            label: "Auto-Update",
            name: "Agent Host",
          },
          {
            id: "Gateway",
            label: "Gateway",
            name: "Agent Host",
          },
          {
            id: "Failed",
            label: "Failed",
            name: "Agent Host",
          },
        ],
        metabases: [
          {
            id: "All",
            label: "All",
            name: "Metabase",
          },
          {
            id: "Save",
            label: "Save",
            name: "Metabase",
          },
          {
            id: "Group Certificate",
            label: "Group Certificate",
            name: "Metabase",
          },
          {
            id: "Agent Config",
            label: "Agent Config",
            name: "Metabase",
          },
          {
            id: "Policy",
            label: "Policy",
            name: "Metabase",
          },
          {
            id: "Failed",
            label: "Failed",
            name: "Metabase",
          },
        ],
        taskStatuses: [
          {
            id: "All",
            label: "All",
            name: "Task Status",
          },
          {
            id: "Expired",
            label: "Expired",
            name: "Task Status",
          },
          {
            id: "Aborted",
            label: "Aborted",
            name: "Task Status",
          },
          {
            id: "Scheduled",
            label: "Scheduled",
            name: "Task Status",
          },
          {
            id: "Succeeded",
            label: "Succeeded",
            name: "Task Status",
          },
          {
            id: "Invalid",
            label: "Invalid",
            name: "Task Status",
          },
          {
            id: "Failed",
            label: "Failed",
            name: "Task Status",
          },
        ],
      },
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit("dataChange", this.data);
      },
    },
  },
  mounted() {
    this.getSource("Defination/GetOsList", "os", "osName", "OS");
  },
  methods: {
    getSource(endpoint, data, key, name) {
      api.get(endpoint, null).then((response) => {
        this.source[data] = response.data.entityData.map((i) => {
          return { id: i.id, label: i[key], name: name };
        });
      });
    },
    onSiteChange(data) {
      this.selectedSite = data;
    },
    onGroupChange(data) {
      this.selectedGroups = data;
      this.$emit("change", data);
    },
    onGroupLoaded(data) {
      if (this.selectedGroups.length === 0) {
        const groupData = data.map((e) => {
          return {
            label: e.name,
            value: e.groupGuid,
          };
        });
        this.$emit("changeOnAllGroup", groupData);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-form-control {
  margin-bottom: 12px;
}

.ag-form-control.radio-group {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  font-size: 11px !important;
  margin-bottom: 15px;
}

.ag-form-control.radio-group div {
  width: 25%;
  display: grid;
  grid-template-columns: repeat(3, 3fr);
  grid-column-gap: 4px;
  grid-row-gap: 4px;
}

.ag-form-control.radio-group label {
  width: 19%;
  display: flex;
  height: 20px;
}

.ag-form-control.radio-group .all-radio {
  width: 14% !important;

}
</style>
